
import { AppService } from "app/services/app.service";
import { Observable } from "rxjs";

export abstract class AbSms extends AppService {
  abstract registrarConfiguracao(config: any);
  abstract getConfigSmsByIntegradorId(codigo): Observable<any>;
  abstract getTotalSmsMesAtualByIntegradorId(codigo): Observable<any>;
  abstract getTotalSmsEnviadosUltimoAnoByIntegradorId(codigo): Observable<any>;
}